import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCardChoropleth from '../components/MapCardChoropleth';
import Base from './Base';
import LoadingScreen from '../components/LoadingScreen'; // Import the LoadingScreen component
import UserStore from '../stores/UserStore';

class Mapstat extends Component {

  constructor() {
  super();
  this.convertGeoJson = this.convertGeoJson.bind(this);
  this.state = {
      mapSouthWest: { lat: null, lng: null },
      mapNorthEast: { lat: null, lng: null },
      mapMinZoom:5,
      geojson: {},
       dataColumns:[],
       searchCriteria: [{name:'Successionsmarknad', id:0, pageClass: 'card' , fields:{
               'area_category':{'value':'2', 'title':'Områdestyp', 'type':'dropdown',
                   'options':[
                       {'name':'Delomraden sverige','value':'2'},
                       {'name':'Deso','value':'1'},
                       {'name':'kv100','value':'3'}
                   ], 'placeholder':'countyg'},
              'housing_type':{'value':'apt', 'title':'Bostadstyp', 'type':'dropdown',
                  'options':[
                      {'name':'Villor/radhus','value':'house'},
                      {'name':'Bostadsrätter','value':'apt'},
                      {'name':'1 Rok','value':'oneroom'},
                      {'name':'2 Rok','value':'tworoom'},
                      {'name':'3 Rok','value':'threeroom'},
                      {'name':'4 Rok','value':'fourroom'},
                      {'name':'5 Rok','value':'fiveroom_plus'},
                      {'name':'Totalt','value':'total'}
                  ]},

              'method':{'value':'avg_recounted_psqm_n_best', 'title':'Metod', 'type':'dropdown',
                  'options':[
                      {'name':'Kvadratmeterpris - medel','value':'avg_recounted_psqm_n_best'},
                      {'name':'Pris - medel', 'value':'avg_recounted_price_n_best'},
                      {'name':'Månadsavgift - medel', 'value':'mean_yearly_fee_sales'},
                      {'name':'Byggår - medel', 'value':'sales_byear_mean'},
                      {'name':'Boarea - medel', 'value':'mean_area_sales_n_best'},
                      {'name':'Antal försäljningar per år', 'value': 'number_of_sales_per_year'}
                  ]},
               'valid_at':{'value':'2025-07-01', 'title':'Datum', 'type':'dropdown',
                   'options':[{'name':'2022-01','value':'2022-01-15'},
                       {'name':'2022-02','value':'2022-02-15'},
                       {'name':'2022-03','value':'2022-03-15'},
                       {'name':'2022-04','value':'2022-04-15'},
                       {'name':'2022-05','value':'2022-05-15'},
                       {'name':'2022-06','value':'2022-06-15'},
                       {'name':'2022-07','value':'2022-07-15'},
                       {'name':'2022-08','value':'2022-08-15'},
                       {'name':'2022-09','value':'2022-09-15'},
                       {'name':'2022-10','value':'2022-10-15'},
                       {'name':'2022-11','value':'2022-11-15'},
                       {'name':'2022-12','value':'2022-12-15'},
                       {'name':'2023-01','value':'2023-01-15'},
                       {'name':'2023-02','value':'2023-02-15'},
                       {'name':'2023-03','value':'2023-03-15'}

                   ]},
              'dynamic_colour':{'value':true, 'title':'Dynamisk färgskala', 'type':'checkbox'},
               'lock_colour':{'value':false, 'title':'Lås färgskala', 'type':'checkbox'}
          }}],
      colorMapping: [],
       mapPositionLat: 59.274472,
       mapPositionLng: 17.944866,
       mapZoomLevel: 13,
       searchInProgress: false,
       dynamicColours: true,
       lockedColours: false
     }
     this.makeMapstatSearch = this.makeMapstatSearch.bind(this);
     this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
     this.getPolygonColor = this.getPolygonColor.bind(this);
     this.updateValidDatesForCategoryAndFields = this.updateValidDatesForCategoryAndFields.bind(this);

  }

    onMapMoveBounds = (southWest, northEast) => {
        this.setState({
            mapSouthWest: {
                lat: southWest.lat,
                lng: southWest.lng
            },
            mapNorthEast: {
                lat: northEast.lat,
                lng: northEast.lng
            }
        });
    }

    convertGeoJson(geoJson, dataInformation) {
        const newFeatures = [];
        for (let feature of (geoJson.features || [])) {
            newFeatures.push({
                type: feature.geometry.type,
                coordinates: feature.geometry.coordinates,
                properties: dataInformation[feature.properties.id]
            });
        }
        geoJson.features = newFeatures;
        return geoJson;
    }

    updateSearchCriteria(event) {
        if (!event || !event.target) {
            return;
        }
        
        // Capture all event.target data IMMEDIATELY before any async operations
        const sectionid = event.target.getAttribute('sectionid');
        const fieldName = event.target.name;
        const targetValue = event.target.value;
        const targetClassName = event.target.className;

        // build a clean copy
        const nextCriteria = this.state.searchCriteria.map((s, i) => {
            if (String(i) !== String(sectionid)) return s;
            const nextFields = { ...s.fields };

            if (targetClassName === 'form-check-input') {
                if (fieldName === 'dynamic_colour') {
                    const newVal = !this.state.dynamicColours;
                    nextFields[fieldName] = { ...nextFields[fieldName], value: newVal };
                    this.setState({ dynamicColours: newVal });
                } else if (fieldName === 'lock_colour') {
                    const newVal = !this.state.lockedColours;
                    nextFields[fieldName] = { ...nextFields[fieldName], value: newVal };
                    this.setState({ lockedColours: newVal });
                }
            } else {
                nextFields[fieldName] = { ...nextFields[fieldName], value: targetValue };
            }

            return { ...s, fields: nextFields };
        });

        this.setState({ searchCriteria: nextCriteria }, () => {
            // Zoom rule for area_category - use captured value instead of event.target.value
            if (fieldName === 'area_category') {
                this.setState({ mapMinZoom: targetValue === '3' ? 2 : 5 });
            }
            
            // Auto-trigger search when criteria change (except for checkbox changes)
            if (targetClassName !== 'form-check-input') {
                this.makeMapstatSearch();
            }
        });

        // When category/housing/method change → refresh available dates (async operation moved outside setState callback)
        if (fieldName === 'area_category' || fieldName === 'housing_type' || fieldName === 'method') {
            this.updateValidDatesForCategoryAndFields();
        }
    }

    getPolygonColor(d) {
        for (let i = 0; i < this.state.colorMapping.length; i++) {
            if (Number(d) < this.state.colorMapping[i].threshold) {
                return this.state.colorMapping[i].color;
            }
        }
        const last = this.state.colorMapping[this.state.colorMapping.length - 1];
        if (last && Number(d) >= last.threshold) return last.color;
        return '#FFEDA0';
    }

    generateColorRange(minValue, maxValue, step, minColor, maxColor) {
        const range = [];
        const totalSteps = (maxValue - minValue) / step;

        function hexToRgb(hex) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null;
        }
        function rgbToHex(r, g, b) {
            return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
        }

        const minRGB = hexToRgb(minColor);
        const maxRGB = hexToRgb(maxColor);

        for (let i = 0; i <= totalSteps; i++) {
            const valueRatio = i / totalSteps;
            const r = minRGB.r + (maxRGB.r - minRGB.r) * valueRatio;
            const g = minRGB.g + (maxRGB.g - minRGB.g) * valueRatio;
            const b = minRGB.b + (maxRGB.b - minRGB.b) * valueRatio;
            range.push({ threshold: minValue + step * i, color: rgbToHex(Math.round(r), Math.round(g), Math.round(b)) });
        }
        return range;
    }

    updateValidDatesForCategoryAndFields = async () => {
        const token = this.state.token || (await UserStore.getAccessToken().catch(() => ''));
        if (!token) {
            console.error('Authentication required to load date options');
            return;
        }
        const headers = { Accept: 'application/json', Authorization: `Bearer ${token}` };

        const current = this.state.searchCriteria[0].fields.valid_at.value;
        const categoryId = this.state.searchCriteria[0].fields.area_category.value;
        const informationFieldName =
            this.state.searchCriteria[0].fields.method.value + '_' + this.state.searchCriteria[0].fields.housing_type.value;

        // Get field id
        const fieldRes = await fetch(
            `${global.apiUrl}/v1/area/information/field?names=${encodeURIComponent(informationFieldName)}`,
            { headers }
        );
        if (fieldRes.status === 401) { 
            console.error('Authentication failed - field request'); 
            UserStore.clear();
            return; 
        }
        if (!fieldRes.ok) return;
        const fieldData = await fieldRes.json();
        const informationFieldId = fieldData?.area_information_fields?.[0]?.id;
        if (!informationFieldId) return;

        // Get dates
        const datesRes = await fetch(
            `${global.apiUrl}/v1/area/information/dates?field_ids=${informationFieldId}&category_ids=${categoryId}`,
            { headers }
        );
        if (datesRes.status === 401) { 
            console.error('Authentication failed - dates request'); 
            UserStore.clear();
            return; 
        }
        if (!datesRes.ok) return;
        const datesData = await datesRes.json();

        const dateList = (datesData.area_information_dates || [])
            .map(item => ({ name: item.valid_from.substring(0, 7), value: item.valid_from }))
            .sort((a, b) => b.value.localeCompare(a.value));

        const nextCriteria = [...this.state.searchCriteria];
        nextCriteria[0] = { ...nextCriteria[0], fields: { ...nextCriteria[0].fields } };
        nextCriteria[0].fields.valid_at = { ...nextCriteria[0].fields.valid_at, options: dateList };

        if (!dateList.some(item => item.name === current.substring(0, 7)) && dateList.length > 0) {
            alert('No data found for the date ==> ' + current.substring(0, 7));
            nextCriteria[0].fields.valid_at.value = dateList[0].value;
        }

        this.setState({ searchCriteria: nextCriteria });
    };

    makeMapstatSearch = async () => {
        if (this.state.searchInProgress) {
            console.log('You need to wait before the earlier one finishes');
            return;
        }

        const token = this.state.token || (await UserStore.getAccessToken().catch(() => ''));
        if (!token) {
            console.error('Authentication required to perform search');
            return;
        }
        const headers = { Accept: 'application/json', Authorization: `Bearer ${token}` };

        this.setState({ searchInProgress: true });

        const categoryId = this.state.searchCriteria[0].fields.area_category.value;
        const infoFieldName =
            this.state.searchCriteria[0].fields.method.value + '_' + this.state.searchCriteria[0].fields.housing_type.value;

        const lat_min = this.state.mapSouthWest.lat;
        const lat_max = this.state.mapNorthEast.lat;
        const lon_min = this.state.mapSouthWest.lng;
        const lon_max = this.state.mapNorthEast.lng;
        const valid_at = this.state.searchCriteria[0].fields.valid_at.value;

        try {
            // 1) field metadata
            const fieldRes = await fetch(
                `${global.apiUrl}/v1/area/information/field?names=${encodeURIComponent(infoFieldName)}`,
                { headers }
            );
            if (fieldRes.status === 401) { 
                console.error('Authentication failed - field metadata request'); 
                UserStore.clear();
                this.setState({ searchInProgress: false });
                return; 
            }
            if (!fieldRes.ok) throw new Error('field metadata failed');
            const fieldData = await fieldRes.json();
            const field = fieldData?.area_information_fields?.[0];
            if (!field) throw new Error('no field id');

            const fieldId = field.id;
            const fieldColourMax = field.colour_max_value;
            const fieldColourMin = field.colour_min_value;
            const fieldColourUnit = field.colour_unit;
            const fieldMaxColour = field.max_colour;
            const fieldMinColour = field.min_colour;

            // 2) map data
            const params = new URLSearchParams({
                category_ids: String(categoryId),
                information_field_id: String(fieldId),
                min_wgs84lat: String(lat_min),
                max_wgs84lat: String(lat_max),
                min_wgs84lon: String(lon_min),
                max_wgs84lon: String(lon_max),
                valid_at: String(valid_at)
            });

            const mapRes = await fetch(`${global.apiUrl}/v1/area/map?${params.toString()}`, { headers });
            if (mapRes.status === 401) { 
                console.error('Authentication failed - map request'); 
                UserStore.clear();
                this.setState({ searchInProgress: false });
                return; 
            }
            if (mapRes.status === 403) { console.warn('Forbidden for this endpoint'); this.setState({ searchInProgress: false }); return; }
            if (!mapRes.ok) throw new Error('map fetch failed');

            const mapData = await mapRes.json();
            const features = mapData?.features || [];

            // dynamic/static color mapping
            if (!this.state.lockedColours) {
                if (this.state.dynamicColours) {
                    const values = features.map(f => f?.properties?.field_value).filter(v => typeof v === 'number');
                    if (values.length) {
                        const maxDataValue = Math.max(...values);
                        const minDataValue = Math.min(...values);
                        const colours = ['#FFEDA0', '#FED976', '#FEB24C', '#FD8D3C', '#FC4E2A', '#E31A1C', '#BD0026', '#800026'];
                        const step = (maxDataValue - minDataValue) / (colours.length - 1 || 1);
                        const mapping = colours.map((c, i) => ({ threshold: minDataValue + i * step, color: c }));
                        this.setState({ colorMapping: mapping });
                    }
                } else {
                    const mapping = this.generateColorRange(fieldColourMin, fieldColourMax, fieldColourUnit, fieldMinColour, fieldMaxColour);
                    this.setState({ colorMapping: mapping });
                }
            }

            this.setState({ geojson: mapData, searchInProgress: false });
        } catch (err) {
            console.error(err);
            this.setState({ searchInProgress: false });
        }
    };

    async componentDidMount() {
        try {
            const userToken = await UserStore.getAccessToken();
            if (userToken) {
                this.setState({ token: userToken }, () => {
                    // load initial valid_at options
                    this.updateValidDatesForCategoryAndFields();
                });
            }
        } catch (e) {
            console.error('Failed to get access token:', e);
        }
    }

    render() {
        return (
            <Base
                pageTopic="Mapstat"
                mainContent={
                    <>
                        {this.state.searchInProgress && <LoadingScreen />}
                        <MapCardChoropleth
                            geojson={this.state.geojson?.features || []}
                            lonName="lon"
                            latName="lat"
                            markerTitle={this.state.markerTopic}
                            markerPopupColumns={this.state.dataColumns}
                            mapPositionLat={this.state.mapPositionLat}
                            mapPositionLng={this.state.mapPositionLng}
                            mapZoomLevel={this.state.mapZoomLevel}
                            mapMinZoom={this.state.mapMinZoom}
                            onMapMoveBounds={this.onMapMoveBounds}
                            getPolygonColor={this.getPolygonColor}
                        />
                    </>
                }
                searchBar={
                    <RightSearchBar
                        searchCriteria={this.state.searchCriteria}
                        updateSearchCriteria={this.updateSearchCriteria}
                        searchFunction={this.makeMapstatSearch}
                        colorMapping={this.state.colorMapping}
                    />
                }
            />
        );
    }
}


export default Mapstat;
